import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close, Search } from "@vfit/ui/icons";
import React, { useEffect, useState } from "react";
import { LoggerInstance } from "@vfit/shared/providers";
import { CloseContainer, SearchBoxContainer, SearchBoxContent } from "./SearchBox.style";
// TODO: Refactoring searchbox: Define overlopperItemId
var SearchBox = function(param) {
    var overlopperItemId = param.overlopperItemId;
    var ref = useState(false), isOpen = ref[0], setIsOpen = ref[1];
    var BREAKPOINT_WIDTH = 1024;
    var BREAKPOINT_TABLET = 766.88;
    var DEFAULT_WIDTH = 200;
    var MAX_DEFAULT_WIDTH = 280;
    var MIN_DEFAULT_WIDTH = 0;
    var CLOSE_ITEM_DEFAULT_WIDTH = 50;
    var CHANGABLED_ITEM_ID = "search-box";
    useEffect(function() {
        if (isOpen) {
            var input = document.getElementById("yxt-SearchBar-input--search-bar");
            if (input) input.focus();
        }
    }, [
        isOpen
    ]);
    useEffect(function() {
        // @ts-ignore
        if (window.initAnswers) {
            setTimeout(function() {
                // @ts-ignore
                window.initAnswers();
                setTimeout(function() {
                    var ref, ref1;
                    var submit = document.getElementsByClassName("yxt-SearchBar-button");
                    if (submit) submit === null || submit === void 0 ? void 0 : (ref = submit[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.parentNode) === null || ref1 === void 0 ? void 0 : ref1.removeChild(submit[0]);
                }, 500);
            }, 500);
        }
        return function() {
            try {
                var ref;
                // @ts-ignore
                if (ANSWERS && (ANSWERS === null || ANSWERS === void 0 ? void 0 : ANSWERS.components)) ANSWERS === null || ANSWERS === void 0 ? void 0 : (ref = ANSWERS.components) === null || ref === void 0 ? void 0 : ref.removeByName("search-bar");
            } catch (e) {
                LoggerInstance.debug("ANSWER is not defined");
            }
        };
    }, []);
    var changeWidth = function() {
        var element = document.getElementById(CHANGABLED_ITEM_ID);
        if (element && window.innerWidth < BREAKPOINT_WIDTH) {
            if (isOpen) {
                if (window.innerWidth < BREAKPOINT_TABLET) {
                    element.style.width = "".concat(DEFAULT_WIDTH, "px");
                } else {
                    element.style.width = "".concat(MAX_DEFAULT_WIDTH, "px");
                }
            } else {
                element.style.width = "".concat(MIN_DEFAULT_WIDTH, "px");
            }
        } else if (!isOpen && element) {
            element.style.width = "".concat(CLOSE_ITEM_DEFAULT_WIDTH, "px");
        } else if (overlopperItemId) {
            var ref, ref1;
            var overlapedItem = (ref = document.getElementById(overlopperItemId)) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
            var changabledItem = (ref1 = document.getElementById(CHANGABLED_ITEM_ID)) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect();
            if (overlapedItem && changabledItem && element) {
                var res = Number(changabledItem === null || changabledItem === void 0 ? void 0 : changabledItem.x) + Number(changabledItem === null || changabledItem === void 0 ? void 0 : changabledItem.width) - Number(overlapedItem === null || overlapedItem === void 0 ? void 0 : overlapedItem.x);
                var width = Math.abs(Number(overlapedItem === null || overlapedItem === void 0 ? void 0 : overlapedItem.width) - Number(res));
                element.style.width = res > MIN_DEFAULT_WIDTH && width < MAX_DEFAULT_WIDTH ? "".concat(width, "px") : "".concat(MAX_DEFAULT_WIDTH, "px");
            }
        }
    };
    var onOpenClose = function() {
        var elementInput = document.getElementById("searchbox-input");
        if (!isOpen && elementInput) {
            elementInput.focus();
        }
        setIsOpen(function(prevState) {
            return !prevState;
        });
    };
    useEffect(function() {
        changeWidth();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        isOpen
    ]);
    window.addEventListener("resize", function() {
        changeWidth();
    });
    return /*#__PURE__*/ _jsx(SearchBoxContainer, {
        children: /*#__PURE__*/ _jsxs(SearchBoxContent, {
            id: CHANGABLED_ITEM_ID,
            isOpen: isOpen,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "search-form",
                    style: {
                        width: "100%",
                        display: isOpen ? "block" : "none"
                    }
                }),
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "searchbox-icon",
                    onClick: onOpenClose,
                    children: isOpen ? /*#__PURE__*/ _jsx(CloseContainer, {
                        children: /*#__PURE__*/ _jsx(Close, {})
                    }) : /*#__PURE__*/ _jsx(Search, {})
                })
            ]
        })
    });
};
export default SearchBox;
